import MuiTypography from '@mui/material/Typography'

import { string, oneOfType, oneOf } from 'prop-types'
import { forwardRef } from 'react'

export const variants = [
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'subtitle1',
	'subtitle2',
	'body1',
	'body2',
	'caption',
	'button',
	'overline',
	'headlinebig',
	'headlinemedium',
	'headlinesmall',
	'subheadline1',
	'subheadline2',
]

const Typography = forwardRef(function Typography({ text, children, ...props }, ref) {
	return (
		<MuiTypography {...props} ref={ref}>
			{children ? children : text}
		</MuiTypography>
	)
})

Typography.defaultProps = {
	...MuiTypography.defaultProps,
	align: 'inherit',
	gutterBottom: false,
	noWrap: false,
	paragraph: false,
	variant: 'body1',
}

Typography.propTypes = {
	...MuiTypography.propTypes,
	/**
	 * This is an example text string
	 */
	text: string,
	/**
	 * Applies the theme typography styles.
	 */
	variant: oneOfType([oneOf(['inherit', 'srOnly', ...variants]), string]),
}

export default Typography
